import { render, staticRenderFns } from "./AppCredentials.vue?vue&type=template&id=50c2c5e0&scoped=true"
import script from "./AppCredentials.vue?vue&type=script&lang=js"
export * from "./AppCredentials.vue?vue&type=script&lang=js"
import style0 from "./AppCredentials.vue?vue&type=style&index=0&id=50c2c5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2c5e0",
  null
  
)

export default component.exports